import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
import { RestaurantGuardOutletContext } from '../../routes/RestaurantGuard';
import { validateAndCorrectLanguage } from '../../i18n';

export const LanguageSelector = () => {
	const { i18n } = useTranslation();
	const { restaurant } = useOutletContext<RestaurantGuardOutletContext>();

	const supportedLocales = restaurant?.supportedLocales || ['en'];
	const showLanguageSelector = supportedLocales.length > 1;

	useEffect(() => {
		validateAndCorrectLanguage(supportedLocales);
	}, [restaurant, supportedLocales]);

	if (!showLanguageSelector) {
		return null;
	}

	const languageLabels: Record<string, string> = {
		en: 'English',
		fr: 'Français'
	};

	return (
		<div className="fixed top-4 right-4 z-50">
			<select
				aria-label="Language"
				className="bg-zinc-800/80 text-white border border-zinc-700/50 rounded-md px-3 py-2 text-sm backdrop-blur-sm hover:bg-zinc-700/80 focus:outline-none focus:ring-2 focus:ring-zinc-500 transition-colors"
				value={i18n.language?.startsWith('fr') ? 'fr' : 'en'}
				onChange={(e) => i18n.changeLanguage(e.target.value)}
			>
				{supportedLocales.map((locale) => (
					<option key={locale} value={locale}>
						{languageLabels[locale] || locale}
					</option>
				))}
			</select>
		</div>
	);
};
